var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "category-list-modal",
      attrs: {
        "close-on-click-modal": false,
        visible: _vm.diaVisible,
        bodyHeight: "235px",
        title: "",
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.diaVisible = $event
        },
        close: function ($event) {
          return _vm.$emit("update:visible", false)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: { "font-weight": "bold" },
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.params.type == "add"
                  ? _vm.$t("after-sales::after-sales-set::add_reason")
                  : _vm.params.type == "next"
                  ? _vm.$t("after-sales::after-sales-set::add_reason_add_sub")
                  : _vm.$t("after-sales::after-sales-set::add_reason_add_edit")
              ) +
              " "
          ),
        ]
      ),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.cateloading,
              expression: "cateloading",
            },
          ],
          ref: "form",
          staticClass: "cate-body",
          attrs: {
            model: _vm.params,
            rules: _vm.rules,
            "label-width": "100px",
          },
        },
        [
          ((_vm.params.type == "edit" &&
            _vm.params.row &&
            _vm.params.row.parentId !== 0) ||
            _vm.params.type === "add") &&
          _vm.visible
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "after-sales::after-sales-set::add_reason_parent_cate"
                    ),
                    prop: "category",
                  },
                },
                [
                  _c("el-cascader", {
                    ref: "casc",
                    staticClass: "input-item",
                    attrs: {
                      disabled:
                        _vm.params.type !== "add" &&
                        _vm.params.row &&
                        _vm.params.row.childrens &&
                        _vm.params.row.childrens.length !== 0,
                      options: _vm.tableData,
                      props: _vm.props,
                      clearable: "",
                      filterable: "",
                    },
                    on: { change: _vm.handleCase },
                    model: {
                      value: _vm.params.category,
                      callback: function ($$v) {
                        _vm.$set(_vm.params, "category", $$v)
                      },
                      expression: "params.category",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.params.type == "next"
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "after-sales::after-sales-set::add_reason_parent_cate"
                    ),
                  },
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.parentCate ? _vm.parentCate : "/")),
                  ]),
                ]
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "after-sales::after-sales-set::add_responsible_party"
                ),
                prop: "dutyId",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "input-item",
                  attrs: {
                    placeholder: _vm.$t(
                      "after-sales::after-sales-set::add_responsible_party_holder"
                    ),
                  },
                  model: {
                    value: _vm.params.dutyId,
                    callback: function ($$v) {
                      _vm.$set(_vm.params, "dutyId", $$v)
                    },
                    expression: "params.dutyId",
                  },
                },
                _vm._l(_vm.dutyIds, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("after-sales::after-sales-set::add_reason_type"),
                prop: "name",
              },
            },
            [
              _c("el-input", {
                staticClass: "input-item",
                attrs: { maxlength: "20" },
                model: {
                  value: _vm.params.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.params,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "params.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.$emit("update:visible", false)
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("after-sales::after-sales-set::add_cancel")) +
                  " "
              ),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading, type: "primary" },
              on: { click: _vm.onSave },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("after-sales::after-sales-set::add_save")) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }